<template>
    <div class="Input InputRadioButton">
        <el-radio-group
                v-model="localModel"
                :name="'input-' + name">
            <el-radio-button
                v-if="key != '_config'"
                v-for="(label, key) in items"
                :label="key"
                :key="key"
                :class="{ error: localErrors.length }"
                tabindex="0"
            />

        </el-radio-group>
        <div v-if="errors" class="Input__error">{{localErrors[0]}}</div>
    </div>
</template>

<style lang="sass">
    @import ../../../common/styles/mixins
    @import ../../../common/styles/settings

    .InputRadioButton

        &__error
            color: $color-base
            font-size: 0.875rem
            position: absolute
            bottom: -1.5rem
            left: 3rem

        .el-radio-group
            display: flex
            justify-content: flex-start
            flex-wrap: nowrap
            position: relative
            +media("<1024px")
                flex-wrap: wrap

        .el-radio-button:last-child .el-radio-button__inner,
        .el-radio-button:first-child .el-radio-button__inner
            border-radius: 2px
            border: 1px solid $color-gray-dark
            box-shadow: none
            background-color: $color-white

        // .el-radio-button:focus:not(.is-focus):not(:active):not(.is-disabled)
        //     box-shadow: none

        .el-radio-button
            margin: 0 0 0 1rem
            min-width: 20rem
            &:first-child
                margin-left: 0
            +media("<1024px")
                width: 100%
                margin: 0 0 20px

                .node-contact__field &
                    &:last-of-type
                        margin-bottom: 0

            &:focus
                &__inner
                    border: 1px solid #1b76c4

            &:hover
                box-shadow: 0 0 4px rgba(0,0,0,0.4)

            &.error
                .el-radio-button__inner
                    border: 1px solid $color-base

            &__inner
                padding: 1.25rem 40px 1.25rem 66px
                width: 100%
                border: 1px solid $color-gray-dark
                border-radius: 2px
                color: $color-text
                background-color: transparent
                font-weight: 400
                white-space: inherit
                line-height: 24px
                font-size: 16px
                justify-content: flex-start
                text-align: left
                &:before
                    +pseudo((width: 24px, height: 24px, right: auto, top: 50%))
                    left: 16px
                    border: 1px solid $color-gray-dark
                    background-color: $color-white
                    border-radius: 50%
                    transform: translateY(-50%)

                &:focus
                    outline: none

        .el-radio-button__inner:hover
        .el-radio-button:last-child .el-radio-button__inner:hover,
        .el-radio-button:first-child .el-radio-button__inner:hover
            box-shadow: 0 0 4px rgba(0,0,0,0.4)

        .el-radio-button__orig-radio:checked+.el-radio-button__inner
            background-color: rgba(206, 14, 74, 0.05)
            color: $color-text
            box-shadow: none

        .el-radio-button__orig-radio:checked+.el-radio-button__inner
            position: relative
            &:after
                +pseudo((width: 14px, height: 14px, right: auto, top: 50%))
                left: 22px
                background-color: $color-base2
                border-radius: 50%
                transform: translateY(-50%)
                z-index: 1

</style>

<script>

    export default {
        props: ["name", "value", "items", "errors"],
        data() {
            return {
                localModel: this.value,
                localErrors: this.errors || []
            }
        },
        watch: {
            localModel(val) {
                this.$emit("input", val);
                this.$emit("change");
            },
            value: function(newVal, oldVal) {
                this.localModel = newVal;
            },
            errors: function(newVal, oldVal) {
                this.localErrors = newVal || [];
            }
        }
    }

</script>
